// src/components/appSettings/Contact/ContactInfoForm/ContactFormSections.jsx
import React from "react";
import {
  FiInfo,
  FiImage,
  FiX,
  FiUpload,
  FiPlus,
  FiTrash2,
} from "react-icons/fi";

// ============= BASIC INFO SECTION =============
export const ContactBasicInfoSection = ({
  formData,
  errors,
  branches,
  onChange,
}) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-medium mb-4">Basic Information</h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Branch Code *
        </label>
        <select
          name="branchCode"
          value={formData.branchCode}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors.branchCode ? "border-red-500" : "border-gray-300"
          }`}
        >
          <option value="">Select branch</option>
          {branches?.map((branch) => (
            <option key={branch.code} value={branch.code}>
              {branch.name} ({branch.code})
            </option>
          ))}
        </select>
        {errors.branchCode && (
          <p className="mt-1 text-sm text-red-500">{errors.branchCode}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Store Name *
        </label>
        <input
          type="text"
          name="storeName"
          value={formData.storeName}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors.storeName ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="Enter store name"
        />
        {errors.storeName && (
          <p className="mt-1 text-sm text-red-500">{errors.storeName}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Established Year
        </label>
        <input
          type="number"
          name="establishedYear"
          value={formData.establishedYear}
          onChange={onChange}
          min="1900"
          max={new Date().getFullYear()}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>

      <div className="flex items-center">
        <label className="flex items-center mt-6">
          <input
            type="checkbox"
            name="isMainBranch"
            checked={formData.isMainBranch}
            onChange={onChange}
            className="rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="ml-2 text-sm font-medium text-gray-700">
            Main Branch
          </span>
        </label>
      </div>

      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Description
        </label>
        <textarea
          name="storeDescription"
          value={formData.storeDescription}
          onChange={onChange}
          rows="3"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Brief description of this location"
        />
      </div>

      <div className="md:col-span-2">
        <label className="flex items-center">
          <input
            type="checkbox"
            name="isActive"
            checked={formData.isActive}
            onChange={onChange}
            className="rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="ml-2 text-sm font-medium text-gray-700">
            Active (Visible to customers)
          </span>
        </label>
      </div>
    </div>
  </div>
);

// ============= CONTACT DETAILS SECTION =============
export const ContactDetailsSection = ({ formData, errors, onChange }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-medium mb-4">Contact Details</h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Primary Phone *
        </label>
        <input
          type="tel"
          name="contact.primaryPhone"
          value={formData.contact.primaryPhone}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["contact.primaryPhone"]
              ? "border-red-500"
              : "border-gray-300"
          }`}
          placeholder="+91 1234567890"
        />
        {errors["contact.primaryPhone"] && (
          <p className="mt-1 text-sm text-red-500">
            {errors["contact.primaryPhone"]}
          </p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Secondary Phone
        </label>
        <input
          type="tel"
          name="contact.secondaryPhone"
          value={formData.contact.secondaryPhone}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="+91 1234567890"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Email *
        </label>
        <input
          type="email"
          name="contact.email"
          value={formData.contact.email}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["contact.email"] ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="store@example.com"
        />
        {errors["contact.email"] && (
          <p className="mt-1 text-sm text-red-500">{errors["contact.email"]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          WhatsApp Number
        </label>
        <input
          type="tel"
          name="contact.whatsapp"
          value={formData.contact.whatsapp}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="+91 1234567890"
        />
      </div>

      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Website
        </label>
        <input
          type="url"
          name="contact.website"
          value={formData.contact.website}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://www.example.com"
        />
      </div>
    </div>
  </div>
);

// ============= ADDRESS SECTION =============
export const AddressSection = ({ formData, errors, onChange }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-medium mb-4">Address</h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Address Line 1 *
        </label>
        <input
          type="text"
          name="address.line1"
          value={formData.address.line1}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["address.line1"] ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="Street address, building name"
        />
        {errors["address.line1"] && (
          <p className="mt-1 text-sm text-red-500">{errors["address.line1"]}</p>
        )}
      </div>

      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Address Line 2
        </label>
        <input
          type="text"
          name="address.line2"
          value={formData.address.line2}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Apartment, suite, floor (optional)"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Landmark
        </label>
        <input
          type="text"
          name="address.landmark"
          value={formData.address.landmark}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Near xyz, opposite abc"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          City *
        </label>
        <input
          type="text"
          name="address.city"
          value={formData.address.city}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["address.city"] ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="City"
        />
        {errors["address.city"] && (
          <p className="mt-1 text-sm text-red-500">{errors["address.city"]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          State *
        </label>
        <input
          type="text"
          name="address.state"
          value={formData.address.state}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["address.state"] ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="State"
        />
        {errors["address.state"] && (
          <p className="mt-1 text-sm text-red-500">{errors["address.state"]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Pincode *
        </label>
        <input
          type="text"
          name="address.pincode"
          value={formData.address.pincode}
          onChange={onChange}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
            errors["address.pincode"] ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="123456"
        />
        {errors["address.pincode"] && (
          <p className="mt-1 text-sm text-red-500">
            {errors["address.pincode"]}
          </p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Country
        </label>
        <input
          type="text"
          name="address.country"
          value={formData.address.country}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="India"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Latitude
        </label>
        <input
          type="number"
          name="address.coordinates.latitude"
          value={formData.address.coordinates.latitude || ""}
          onChange={onChange}
          step="0.000001"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="19.0760"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Longitude
        </label>
        <input
          type="number"
          name="address.coordinates.longitude"
          value={formData.address.coordinates.longitude || ""}
          onChange={onChange}
          step="0.000001"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="72.8777"
        />
      </div>

      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Google Maps URL
        </label>
        <input
          type="url"
          name="address.googleMapsUrl"
          value={formData.address.googleMapsUrl}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://maps.google.com/..."
        />
      </div>
    </div>
  </div>
);

// ============= BUSINESS HOURS SECTION =============
export const BusinessHoursSection = ({
  formData,
  errors,
  onChange,
  onBusinessHoursChange,
  onBreakTimeChange,
}) => {
  const dayLabels = {
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium mb-4">Business Hours</h3>

      <div className="space-y-3">
        {formData.businessHours.regular.map((hour, index) => (
          <div
            key={index}
            className="flex flex-col gap-3 p-4 border rounded-lg bg-gray-50"
          >
            {/* Day and Open/Closed Toggle */}
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-gray-700 w-32">
                {dayLabels[hour.day]}
              </span>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={!hour.isOpen}
                  onChange={(e) =>
                    onBusinessHoursChange(index, "isOpen", !e.target.checked)
                  }
                  className="rounded border-gray-300 text-primary focus:ring-primary"
                />
                <span className="ml-2 text-sm text-gray-700">Closed</span>
              </label>
            </div>

            {/* Operating Hours */}
            {hour.isOpen && (
              <>
                <div className="flex items-center gap-2">
                  <label className="text-xs text-gray-600 w-24">
                    Operating Hours:
                  </label>
                  <input
                    type="time"
                    value={hour.openTime}
                    onChange={(e) =>
                      onBusinessHoursChange(index, "openTime", e.target.value)
                    }
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                  <span className="text-gray-500">to</span>
                  <input
                    type="time"
                    value={hour.closeTime}
                    onChange={(e) =>
                      onBusinessHoursChange(index, "closeTime", e.target.value)
                    }
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>

                {/* Break Time */}
                <div className="flex items-center gap-2">
                  <label className="text-xs text-gray-600 w-24">
                    Break Time:
                  </label>
                  <input
                    type="time"
                    value={hour.breakTime?.start || ""}
                    onChange={(e) =>
                      onBreakTimeChange(index, "start", e.target.value)
                    }
                    placeholder="Start"
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                  <span className="text-gray-500">to</span>
                  <input
                    type="time"
                    value={hour.breakTime?.end || ""}
                    onChange={(e) =>
                      onBreakTimeChange(index, "end", e.target.value)
                    }
                    placeholder="End"
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 bg-blue-50 rounded-lg p-3 flex items-start gap-2">
        <FiInfo className="text-blue-600 mt-0.5" />
        <p className="text-xs text-blue-800">
          Set your regular business hours and break times. You can add special
          hours and holidays separately if needed.
        </p>
      </div>
    </div>
  );
};

// ============= SOCIAL MEDIA SECTION =============
export const SocialMediaSection = ({ formData, errors, onChange }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-medium mb-4">Social Media</h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Facebook
        </label>
        <input
          type="url"
          name="socialMedia.facebook"
          value={formData.socialMedia.facebook}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://facebook.com/yourpage"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Instagram
        </label>
        <input
          type="url"
          name="socialMedia.instagram"
          value={formData.socialMedia.instagram}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://instagram.com/yourpage"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Twitter
        </label>
        <input
          type="url"
          name="socialMedia.twitter"
          value={formData.socialMedia.twitter}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://twitter.com/yourpage"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          YouTube
        </label>
        <input
          type="url"
          name="socialMedia.youtube"
          value={formData.socialMedia.youtube}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://youtube.com/yourchannel"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          LinkedIn
        </label>
        <input
          type="url"
          name="socialMedia.linkedin"
          value={formData.socialMedia.linkedin}
          onChange={onChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="https://linkedin.com/company/yourcompany"
        />
      </div>
    </div>
  </div>
);

// ============= SUPPORT CHANNELS SECTION =============
export const SupportChannelsSection = ({ formData, errors, onChange }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h3 className="text-lg font-medium mb-4">Support Channels</h3>

    {/* Customer Care Section */}
    <div className="mb-6">
      <h4 className="text-md font-medium text-gray-800 mb-3">Customer Care</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone Number
          </label>
          <input
            type="tel"
            name="support.customerCare.phone"
            value={formData.support.customerCare.phone}
            onChange={onChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="+91 1234567890"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            name="support.customerCare.email"
            value={formData.support.customerCare.email}
            onChange={onChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="support@example.com"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Support Timings
          </label>
          <input
            type="text"
            name="support.customerCare.timings"
            value={formData.support.customerCare.timings}
            onChange={onChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Mon-Sat: 9 AM - 6 PM"
          />
        </div>
      </div>
    </div>

    {/* WhatsApp Support Section */}
    <div className="mb-6">
      <h4 className="text-md font-medium text-gray-800 mb-3">
        WhatsApp Support
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="flex items-center mb-2">
            <input
              type="checkbox"
              name="support.whatsappSupport.enabled"
              checked={formData.support.whatsappSupport.enabled}
              onChange={onChange}
              className="rounded border-gray-300 text-primary focus:ring-primary"
            />
            <span className="ml-2 text-sm font-medium text-gray-700">
              Enable WhatsApp Support
            </span>
          </label>
        </div>

        <div>
          <label className="flex items-center mb-2">
            <input
              type="checkbox"
              name="support.whatsappSupport.businessAccount"
              checked={formData.support.whatsappSupport.businessAccount}
              onChange={onChange}
              className="rounded border-gray-300 text-primary focus:ring-primary"
            />
            <span className="ml-2 text-sm font-medium text-gray-700">
              Business Account
            </span>
          </label>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            WhatsApp Number
          </label>
          <input
            type="tel"
            name="support.whatsappSupport.number"
            value={formData.support.whatsappSupport.number}
            onChange={onChange}
            disabled={!formData.support.whatsappSupport.enabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-gray-100"
            placeholder="+91 1234567890"
          />
        </div>
      </div>
    </div>

    {/* Chat Support Section */}
    <div>
      <h4 className="text-md font-medium text-gray-800 mb-3">
        Live Chat Support
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="flex items-center mb-2">
            <input
              type="checkbox"
              name="support.chatSupport.enabled"
              checked={formData.support.chatSupport.enabled}
              onChange={onChange}
              className="rounded border-gray-300 text-primary focus:ring-primary"
            />
            <span className="ml-2 text-sm font-medium text-gray-700">
              Enable Live Chat
            </span>
          </label>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chat Platform
          </label>
          <input
            type="text"
            name="support.chatSupport.platform"
            value={formData.support.chatSupport.platform}
            onChange={onChange}
            disabled={!formData.support.chatSupport.enabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-gray-100"
            placeholder="e.g., Intercom, Tawk.to, Zendesk"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Widget ID
          </label>
          <input
            type="text"
            name="support.chatSupport.widgetId"
            value={formData.support.chatSupport.widgetId}
            onChange={onChange}
            disabled={!formData.support.chatSupport.enabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-gray-100"
            placeholder="Widget/Script ID from your chat provider"
          />
        </div>
      </div>
    </div>
  </div>
);

// ============= SERVICES SECTION =============
export const ServicesSection = ({ formData, errors, onChange }) => {
  const services = [
    { key: "homeDelivery", label: "Home Delivery" },
    { key: "videoShopping", label: "Video Shopping" },
    { key: "appointmentBooking", label: "Appointment Booking" },
    { key: "customDesign", label: "Custom Design" },
    { key: "repair", label: "Repair Services" },
    { key: "exchange", label: "Exchange" },
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium mb-4">Services Offered</h3>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {services.map((service) => (
          <label key={service.key} className="flex items-center">
            <input
              type="checkbox"
              name={`services.${service.key}`}
              checked={formData.services[service.key]}
              onChange={onChange}
              className="rounded border-gray-300 text-primary focus:ring-primary"
            />
            <span className="ml-2 text-sm text-gray-700">{service.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

// ============= IMAGES SECTION =============
export const ImagesSection = ({
  imagePreviews,
  onImageChange,
  onRemoveImage,
  onRemoveInteriorImage,
}) => (
  <div className="bg-white rounded-lg shadow p-6">
    <div className="flex items-center gap-2 mb-4">
      <FiImage className="text-gray-600" />
      <h3 className="text-lg font-medium">Store Images</h3>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Store Front Image */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Store Front Image
        </label>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
          {imagePreviews.storeFront ? (
            <div className="relative">
              <img
                src={imagePreviews.storeFront}
                alt="Store Front"
                className="max-h-40 mx-auto rounded"
              />
              <button
                type="button"
                onClick={() => onRemoveImage("storeFront")}
                className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
              >
                <FiX size={16} />
              </button>
              <p className="text-xs text-gray-500 mt-2">Click X to remove</p>
            </div>
          ) : (
            <div className="py-8">
              <FiUpload className="mx-auto text-gray-400 text-3xl mb-2" />
              <p className="text-sm text-gray-600">Upload store front image</p>
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => onImageChange(e, "storeFront")}
            className="mt-2"
          />
        </div>
      </div>

      {/* Logo */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Store Logo
        </label>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
          {imagePreviews.logo ? (
            <div className="relative">
              <img
                src={imagePreviews.logo}
                alt="Logo"
                className="max-h-40 mx-auto rounded"
              />
              <button
                type="button"
                onClick={() => onRemoveImage("logo")}
                className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
              >
                <FiX size={16} />
              </button>
              <p className="text-xs text-gray-500 mt-2">Click X to remove</p>
            </div>
          ) : (
            <div className="py-8">
              <FiUpload className="mx-auto text-gray-400 text-3xl mb-2" />
              <p className="text-sm text-gray-600">Upload logo</p>
            </div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => onImageChange(e, "logo")}
            className="mt-2"
          />
        </div>
      </div>

      {/* Interior Images */}
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Interior Images (Maximum 4)
        </label>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
          {imagePreviews.interior && imagePreviews.interior.length > 0 ? (
            <div className="grid grid-cols-3 md:grid-cols-4 gap-2 mb-4">
              {imagePreviews.interior.map((url, index) => (
                <div key={index} className="relative group">
                  <img
                    src={url}
                    alt={`Interior ${index + 1}`}
                    className="h-24 w-full object-cover rounded"
                  />
                  <button
                    type="button"
                    onClick={() => onRemoveInteriorImage(index)}
                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <FiX size={14} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-8 text-center mb-4">
              <FiUpload className="mx-auto text-gray-400 text-3xl mb-2" />
              <p className="text-sm text-gray-600">Upload interior images</p>
            </div>
          )}

          {imagePreviews.interior.length < 4 ? (
            <>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => onImageChange(e, "interior")}
                className="w-full"
              />
              <p className="text-xs text-gray-500 mt-2">
                {imagePreviews.interior.length === 0
                  ? "You can select up to 4 images"
                  : `${
                      imagePreviews.interior.length
                    } of 4 images selected. You can add ${
                      4 - imagePreviews.interior.length
                    } more.`}
              </p>
            </>
          ) : (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center">
              <p className="text-sm text-yellow-800">
                Maximum of 4 images reached. Remove an image to add another.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

// ============= CERTIFICATIONS SECTION =============
export const CertificationsSection = ({
  formData,
  onCertificationChange,
  onAddCertification,
  onRemoveCertification,
  onCertificationImageChange,
  onRemoveCertificationImage,
}) => (
  <div className="bg-white rounded-lg shadow p-6">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-medium">Certifications</h3>
      <button
        type="button"
        onClick={onAddCertification}
        className="flex items-center gap-2 px-3 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
      >
        <FiPlus /> Add Certification
      </button>
    </div>

    {formData.certifications && formData.certifications.length > 0 ? (
      <div className="space-y-4">
        {formData.certifications.map((cert, index) => (
          <div key={index} className="border rounded-lg p-4 bg-gray-50">
            <div className="flex items-start justify-between mb-3">
              <h4 className="font-medium text-gray-700">
                Certification {index + 1}
              </h4>
              <button
                type="button"
                onClick={() => onRemoveCertification(index)}
                className="text-red-500 hover:text-red-700"
              >
                <FiTrash2 />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Certification Name *
                </label>
                <input
                  type="text"
                  value={cert.name || ""}
                  onChange={(e) =>
                    onCertificationChange(index, "name", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="e.g., BIS Hallmark, ISO 9001"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Issuing Authority
                </label>
                <input
                  type="text"
                  value={cert.authority || ""}
                  onChange={(e) =>
                    onCertificationChange(index, "authority", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="e.g., Bureau of Indian Standards"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Certificate Number
                </label>
                <input
                  type="text"
                  value={cert.number || ""}
                  onChange={(e) =>
                    onCertificationChange(index, "number", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="Certificate number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Valid Until
                </label>
                <input
                  type="date"
                  value={cert.validUntil ? cert.validUntil.split("T")[0] : ""}
                  onChange={(e) =>
                    onCertificationChange(index, "validUntil", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Certificate Image
                </label>
                <div className="flex items-center gap-2">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => onCertificationImageChange(e, index)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                  {cert.image && cert.image !== "pending_upload" && (
                    <button
                      type="button"
                      onClick={() => onRemoveCertificationImage(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FiX size={20} />
                    </button>
                  )}
                </div>
                {cert.image && cert.image !== "pending_upload" && (
                  <p className="text-xs text-gray-500 mt-1">
                    Image attached:{" "}
                    {typeof cert.image === "string"
                      ? "Existing file"
                      : "Ready to upload"}
                  </p>
                )}
                {cert.image === "pending_upload" && (
                  <p className="text-xs text-green-600 mt-1">
                    New image selected, will be uploaded on save
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="text-center py-8 text-gray-500">
        <p>No certifications added yet</p>
        <p className="text-sm">Click "Add Certification" to get started</p>
      </div>
    )}
  </div>
);
